import { render, staticRenderFns } from "./LegalStructure.vue?vue&type=template&id=677d1796&"
import script from "./LegalStructure.vue?vue&type=script&lang=js&"
export * from "./LegalStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports